import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static values = { url: String };

  async toggle(event) {
    event.preventDefault();
    const wasFavorite =
      this.element.classList.contains("admin-nav-star--active") ||
      this.element.classList.contains("admin-nav-star--favorite");
    const key = this.element.dataset.favoriteKey;

    if (!key) {
      const response = await post(this.urlValue);
      if (response.ok || response.redirected) {
        window.location.reload();
      }
      return;
    }

    const response = await post(this.urlValue, { responseKind: "turbo-stream" });
    if (!response.ok) return;

    document.querySelectorAll(`[data-favorite-key="${CSS.escape(key)}"]`).forEach((el) => {
      // Favorites-panel stars (--favorite) live inside #admin-nav-favorites, which the
      // turbo-stream response re-renders wholesale; toggling --active on them would
      // force the hover-revealed star permanently visible.
      if (el.classList.contains("admin-nav-star--favorite")) return;
      if (wasFavorite) {
        el.classList.remove("admin-nav-star--active");
        el.setAttribute("title", "Add to favorites");
      } else {
        el.classList.add("admin-nav-star--active");
        el.setAttribute("title", "Remove from favorites");
      }
    });
  }
}
